import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    url: String,
    param: { type: String, default: "position" }
  }

  connect() {
    this.element.setAttribute("data-controller", "sortable")
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: "[data-sortable-handle]",
      onEnd: this.onEnd.bind(this),
      ghostClass: "opacity-50",
      dragClass: "opacity-75",
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  async onEnd(event) {
    const items = Array.from(this.element.querySelectorAll("[data-sortable-item]"))
    const positions = items.map((item, index) => ({
      id: item.dataset.id,
      position: index + 1
    }))

    items.forEach((item, index) => {
      const posEl = item.querySelector("[data-position]")
      if (posEl) posEl.textContent = index + 1
    })

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken()
        },
        body: JSON.stringify({ positions })
      })

      if (!response.ok) {
        console.error("Failed to update positions")
      }
    } catch (error) {
      console.error("Error updating positions:", error)
    }
  }

  csrfToken() {
    return document.querySelector("[name='csrf-token']").content
  }
}
